import news from 'AgentNewsAdministration/ducks/news';
import newsEntry from 'AgentNewsAdministration/ducks/newsEntry';
import {combineReducers} from 'redux';

export default combineReducers({
  news,
  newsEntry,
});
